import React from 'react'
import {
  BriefcaseIcon,
  MapPinIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { cx } from 'class-variance-authority'
import { StaticImage } from 'gatsby-plugin-image'
import { OfferAlgoliaSearchResult } from '../../../../search/offer'
import { formatContractType } from '../../../../offers/format'
import { composeOfferTitle } from '../../../../../Utils/offers/title'
import { Button } from '../../../../ui'

export interface ActiveMapOfferProps {
  offer: OfferAlgoliaSearchResult
  setUnactive: () => void
  isInList?: boolean
  setCenter?: () => void
}

export const ActiveMapOffer = ({
  offer,
  setUnactive,
  isInList = false,
  setCenter = () => undefined,
}: ActiveMapOfferProps) => {
  if (!offer) {
    return null
  }

  const { office, title, firm, contractType, slug } = offer

  const name = office.name || firm.name

  return (
    <button
      id={slug}
      type="button"
      className={cx(
        !isInList &&
        'fixed bottom-1 inset-x-0 lg:hidden cursor-none flex items-center justify-center pb-4',
      )}
      onClick={() => (setCenter ? setCenter() : undefined)}
    >
      <div className="relative overflow-hidden bg-white shadow-md rounded-2xl text-night min-h-[250px] w-[350px] lg:w-[270px] xl:w-[300px] flex flex-col">
        {!isInList && (
          <XMarkIcon
            onClick={setUnactive}
            className="absolute w-6 h-6 p-1 bg-white bg-opacity-75 rounded-full top-2 right-2 backdrop-blur"
          />
        )}
        {firm?.header?.url ? (
          <img
            src={firm?.header?.url}
            alt={`couverture du cabinet ${name}`}
            className="object-cover w-full h-[140px]"
          />
        ) : (
          <StaticImage
            src="/default-header-media.jpg"
            alt={`header ${name}`}
            placeholder="blurred"
            formats={['webp']}
            layout="constrained"
            className="object-cover w-full h-[140px]"
          />
        )}

        <div className="px-4 py-2 space-y-2">
          <h3 className="text-sm font-semibold text-left text-ellipsis text-primary">
            {composeOfferTitle(title)}
          </h3>
          <p className="text-sm font-medium text-left">{name}</p>

          <p className="flex items-center space-x-1 text-xs">
            <MapPinIcon className="w-5 h-5" />
            <span>
              {office.city} ({office.postalCode.slice(0, 2)})
            </span>
          </p>

          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-1">
              <BriefcaseIcon className="w-5 h-5" />
              <span className="text-sm">
                {formatContractType(contractType || '')}
              </span>
            </div>
            <Button
              href={`/cabinets/${firm.slug}/offres/${slug}`}
              label="Voir"
              color="primary"
              size="small"
              invert
            />
          </div>
        </div>
      </div>
    </button>
  )
}
